import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { Headline, BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import { SingleSizeIllustrationHeroOfferProduct } from '@xingternal/illustrations';
import { Divider } from '@xingternal/divider';

import styles from './HeaderImageBanner.css';
import type { HeaderBannerImageType } from './types';

export const MARKETING_URL_EN: string =
  'https://recruiting.xing.com/en/e-recruiting-solutions/employerbrandingprofile';
export const MARKETING_URL_DE: string =
  'https://recruiting.xing.com/de/Arbeitgeberprofil-Upgrade';

const ILLUSTRATION_SIZE = '380px';

const HeaderBannerImage: React.FC<HeaderBannerImageType> = ({
  onClick,
  backLink,
}) => {
  const intl = useIntl();
  const urlMarketing: string =
    intl.locale === 'en' ? MARKETING_URL_EN : MARKETING_URL_DE;

  const handleOnClick = (ev: MouseEvent) => {
    ev.preventDefault();

    onClick && onClick(ev);

    const link =
      urlMarketing +
      '?sc_o= entity_page_companies_start_upsell_cover_image_module&sc_o_PropActionOrigin=entity_page_companies_upgrade_overview';

    window.open(link);
  };

  return (
    <div className={styles.container}>
      <div className={styles.premiumWrapperWithIcon}>
        <div className={styles.contentWrapper}>
          <span className={styles.flag}>
            <FormattedMessage id="EP_FLAG_EMPLOYER_BRANDING_PROFILE" />
          </span>
          <div className={styles.headerText}>
            <Headline size="xlarge">
              <FormattedMessage id="EP_HEADER_IMAGE_BANNER_HEADER" />
            </Headline>
          </div>
          {/* @ts-ignore */}
          <BodyCopy
            className={styles.text}
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({
                id: 'EP_HEADER_IMAGE_BANNER_BODY',
              }),
            }}
          />
        </div>
        <SingleSizeIllustrationHeroOfferProduct
          className={styles.icon}
          width={ILLUSTRATION_SIZE}
        />
      </div>
      <Divider className={styles.headerBannerImageDivider} />
      <div className={styles.buttons}>
        <div>
          <Button
            className={styles.button}
            size="small"
            onClick={onClick}
            to={backLink}
          >
            <FormattedMessage id="EP_HEADER_IMAGE_BANNER_DRAFT_BUTTON" />
          </Button>
        </div>
        <div>
          <Button
            className={styles.button}
            variant="proBusiness"
            size="small"
            onClick={handleOnClick}
            to={urlMarketing}
          >
            <FormattedMessage id="EP_HEADER_IMAGE_BANNER_PUBLISH_BUTTON" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HeaderBannerImage;
